/**
 * Main application entry point.
 *
 * @author Roman Stoian <r.stoyan@infomir.com>.
 */

'use strict';

var keys = require('stb-keys'),
    app = require('mag-app');

if ( TARGET === 'android-stb' || TARGET === 'android-app' ) {
    window.removeEventListener('keydown', require('spa-app/lib/events').keydown);
    require('../../../helpers/longpress.js')(app, {code: keys.ok, emitCode: keys.f3});
}


app.once('load', function () {
    app.api = core.plugins.videoBackend;
    // app.filters = {};

    require('spa-gettext').load({name: core.environment.language}, function ( error ) {
        if ( error ) {
            debug.inspect(error);
        }

        // load pages
        app.pages = {
            main: require('./pages/main'),
            movies: require('./pages/movies'),
            info: require('./pages/info'),
            more: require('./pages/more')
        };

        // show main page
        app.route(app.pages.main);
    });
});
